import React, { useCallback, useEffect, useState } from "react";
import {
  StyledActionButtonsBox,
  StyledAddressBox,
  StyledAddressHeaderBox,
  StyledBoxDefaultInfo,
  StyledLocationInfoBox,
  StyledSetDefaultText,
  StyledTypeContentBox,
  StyledTypographyDefault,
  StyledTypographyHomeInform,
  StyledTypographyWorkInform,
} from "./style";
import theme from "../../theme";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { IconButton, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { SET_DEFAULT_ADDRESS } from "../../actions/AuthActions";

import Confirmation from "../modals/confirmation-modal/Confirmation";
import { DELETE_ADDRESS, GET_ADDRESS_LIST } from "../../actions/AddressActions";
import * as _ from "lodash";

export const AddressLocation = ({ data, setAddressId, setAddAddress }) => {
  const { street_address, city, state, country, address_type, is_default, id } =
    data;

  const dispatch = useDispatch();
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);
  const isPersonalShopper = profileDetails?.user_type === "personal_shopper";
  const getAddress = useCallback(() => {
    dispatch({ type: GET_ADDRESS_LIST });
  }, [dispatch]);

  useEffect(() => {
    getAddress();
  }, [getAddress]);

  const [editConfirmOpen, setEditConfirmOpen] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [defaultDeleteAttempt, setDefaultDeleteAttempt] = useState(false);
  return (
    <StyledBoxDefaultInfo isdefault={is_default ? 1 : 0}>
      <>
        <StyledAddressHeaderBox>
          <StyledTypeContentBox>
            {is_default ? (
              <StyledTypographyHomeInform>
                {_.capitalize(address_type)}
              </StyledTypographyHomeInform>
            ) : (
              <StyledTypographyWorkInform>
                {_.capitalize(address_type)}
              </StyledTypographyWorkInform>
            )}
            {is_default && (
              <Tooltip title="Default" arrow>
                <StyledTypographyDefault>
                  <StarRoundedIcon fontSize="small" />
                </StyledTypographyDefault>
              </Tooltip>
            )}
          </StyledTypeContentBox>

          {!isPersonalShopper && (
            <StyledActionButtonsBox>
              {is_default === false && (
                <StyledSetDefaultText
                  onClick={() => {
                    dispatch({
                      type: SET_DEFAULT_ADDRESS,
                      payload: id,
                    });
                  }}
                >
                  Set as Default
                </StyledSetDefaultText>
              )}

              <Tooltip title="Edit">
                <IconButton
                  onClick={() => {
                    if (is_default) {
                      setEditConfirmOpen(true);
                    } else {
                      setAddressId(id);
                      setAddAddress(true);
                    }
                  }}
                  sx={{ border: `1px solid ${theme.palette.custom.lockerValueColor}`, borderRadius: "8px", padding: "8px" }}
                >
                  <EditIcon sx={{ color: theme.palette.custom.lockerValueColor, fontSize: "20px" }} />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    if (is_default) {
                      setDefaultDeleteAttempt(true);
                    } else {
                      setDeleteConfirmOpen(true);
                    }
                  }}
                  sx={{ border: `1px solid ${theme.palette.error.main}`, borderRadius: "8px", padding: "8px" }}
                >
                  <DeleteIcon sx={{ color: theme.palette.error.main, fontSize: "20px" }} />
                </IconButton>
              </Tooltip>
            </StyledActionButtonsBox>
          )}
        </StyledAddressHeaderBox>

        <StyledLocationInfoBox>
          <LocationOnIcon
            color={is_default === false ? "#757575" : "primary"}
            fontSize="large"
          />
          <StyledAddressBox>
            {street_address}, {city}, {state}, {country}
          </StyledAddressBox>
        </StyledLocationInfoBox>
      </>

      {/* Edit Confirmation Modal */}
      <Confirmation
        open={editConfirmOpen}
        handleClose={() => setEditConfirmOpen(false)}
        heading="Edit Your Default Address"
        message="Are you sure you want to update this default address?"
        confirmButtonLabel="Continue"
        type="info"
        onConfirm={() => {
          setEditConfirmOpen(false);
          setAddressId(id);
          setAddAddress(true);
        }}
      />

      {/* Delete Confirmation Modal */}
      <Confirmation
        open={deleteConfirmOpen}
        handleClose={() => setDeleteConfirmOpen(false)}
        heading="Delete Address"
        message="Are you sure you want to delete this address?"
        confirmButtonLabel="Delete"
        type="delete"
        onConfirm={() => {
          setDeleteConfirmOpen(false);
          dispatch({
            type: DELETE_ADDRESS,
            payload: {
              id,
              onSuccess: () => {
                dispatch({ type: GET_ADDRESS_LIST });
              },
            },
          });
        }}
      />
      {/* Default Confirmation Modal */}
      <Confirmation
        open={defaultDeleteAttempt}
        handleClose={() => setDefaultDeleteAttempt(false)}
        heading="Action Not Allowed"
        message="This is the default address and cannot be deleted"
        confirmButtonLabel="Close"
        type="error"
      />
    </StyledBoxDefaultInfo>
  );
};
